import { supabase } from './supabase';

const SERVER_BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

function isApiRequest(url: string): boolean {
  if (url.startsWith('/api/')) return true;
  if (SERVER_BASE_URL && url.startsWith(`${SERVER_BASE_URL}/api/`)) return true;
  if (API_BASE_URL && url.startsWith(API_BASE_URL)) return true;
  if (SERVER_BASE_URL && url.startsWith(`${SERVER_BASE_URL}/auth/`)) return true;
  return false;
}

export function installAuthFetch(): void {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string'
      ? input
      : input instanceof URL ? input.toString() : input.url;

    if (!isApiRequest(url)) {
      return originalFetch(input, init);
    }

    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) return originalFetch(input, init);

    const headers = new Headers(init?.headers || (typeof input !== 'string' && !(input instanceof URL) ? input.headers : undefined));
    headers.set('Authorization', `Bearer ${token}`);

    return originalFetch(input, { ...(init || {}), headers });
  };
}
